export default "__VITE_ASSET__BxLQHC7V__"